export function isDefaultValueQuery(defaultValue) {
    return !!defaultValue && typeof defaultValue.fromQuery !== 'undefined';
}
